// React
import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

// Styles
import './Body.css'

// Components
import SideBar from './SideBar'
import ColumnsAndCards from './ColumnsAndCards'
import LoadingSpinner from './LoadingSpinner'
import ErrorMessage from './ErrorMessage'
import BoardModal from './BoardModal'

// Hooks
import useBoards from '../hooks/useBoards'

// Store
import { updateBoard, createBoard } from '../store/boardSlice'

const Body = () => {
    const dispatch = useDispatch()
    const { boards, isLoading, error, loadBoards } = useBoards()
    const [activeBoardId, setActiveBoardId] = useState(null)
    const [boardModalOpen, setBoardModalOpen] = useState(false)
    const [editingBoard, setEditingBoard] = useState(null)

    useEffect(() => {
        if (boards.length > 0 && activeBoardId === null) {
            setActiveBoardId(boards[0].numBoard)
        }
    }, [boards])

    if (isLoading) return <LoadingSpinner />
    if (error) return <ErrorMessage message={error} />

    const handleAddBoard = () => {
        setEditingBoard(null)
        setBoardModalOpen(true)
    }

    const handleEditBoard = (board) => {
        setEditingBoard(board)
        setBoardModalOpen(true)
    }

    const handleDeleteBoard = async (board) => {
        try {
            await dispatch(updateBoard({
                numBoard: board.numBoard,
                name: board.name,
                isActive: false,
                emoji: board.emoji
            })).unwrap()

            const remaining = boards.filter(b => b.numBoard !== board.numBoard)
            if (activeBoardId === board.numBoard) {
                setActiveBoardId(remaining[0]?.numBoard ?? null)
            }
            loadBoards()
        } catch (err) {
            console.error('Erro ao excluir quadro:', err)
        }
    }

    const handleSaveBoard = async ({ name, emoji }) => {
        try {
            if (editingBoard) {
                await dispatch(updateBoard({
                    numBoard: editingBoard.numBoard,
                    name,
                    isActive: true,
                    emoji
                })).unwrap()
            } else {
                await dispatch(createBoard({ name, emoji })).unwrap()
            }
            setEditingBoard(null)
            setBoardModalOpen(false)
            loadBoards()
        } catch (err) {
            console.error('Erro ao salvar quadro:', err)
        }
    }

    return (
        <div className='Body'>
            <SideBar
                boards={boards}
                activeBoardId={activeBoardId}
                onSelectBoard={(id) => setActiveBoardId(id)}
                onAddBoard={handleAddBoard}
                onEditBoard={handleEditBoard}
                onDeleteBoard={handleDeleteBoard}
            />
            <ColumnsAndCards boardId={activeBoardId} />

            <BoardModal
                isOpen={boardModalOpen}
                onClose={() => { setBoardModalOpen(false); setEditingBoard(null) }}
                onSave={handleSaveBoard}
                board={editingBoard}
            />
        </div>
    )
}

export default Body